/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MemberManagementCreateMemberAddressRequest } from '../models/MemberManagementCreateMemberAddressRequest';
import type { MemberManagementCreateMemberAddressResponseApiRespoonse } from '../models/MemberManagementCreateMemberAddressResponseApiRespoonse';
import type { MemberManagementDeleteMemberAddressRequest } from '../models/MemberManagementDeleteMemberAddressRequest';
import type { MemberManagementDeleteMemberAddressResponseApiRespoonse } from '../models/MemberManagementDeleteMemberAddressResponseApiRespoonse';
import type { MemberManagementEditMemberAddressRequest } from '../models/MemberManagementEditMemberAddressRequest';
import type { MemberManagementEditMemberAddressResponseApiRespoonse } from '../models/MemberManagementEditMemberAddressResponseApiRespoonse';
import type { MemberManagementListMemberAddressRequest } from '../models/MemberManagementListMemberAddressRequest';
import type { MemberManagementListMemberAddressResponseApiRespoonse } from '../models/MemberManagementListMemberAddressResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MemberManagementMemberAddressService {

    /**
     * 会員住所一覧
     * @param requestBody
     * @returns MemberManagementListMemberAddressResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMemberAddress(
        requestBody: MemberManagementListMemberAddressRequest,
    ): CancelablePromise<MemberManagementListMemberAddressResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/member-address',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 会員住所の新規登録
     * @param requestBody
     * @returns MemberManagementCreateMemberAddressResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMemberAddressCreate(
        requestBody: MemberManagementCreateMemberAddressRequest,
    ): CancelablePromise<MemberManagementCreateMemberAddressResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/member-address/create',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 会員住所の更新
     * @param requestBody
     * @returns MemberManagementEditMemberAddressResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMemberAddressEdit(
        requestBody: MemberManagementEditMemberAddressRequest,
    ): CancelablePromise<MemberManagementEditMemberAddressResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/member-address/edit',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 会員住所の削除
     * @param requestBody
     * @returns MemberManagementDeleteMemberAddressResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMemberAddressDelete(
        requestBody: MemberManagementDeleteMemberAddressRequest,
    ): CancelablePromise<MemberManagementDeleteMemberAddressResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/member-address/delete',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
